const initialState = {
  fetching: false,
  fetched: false,
  items: null,
  error: null,
  nbResult: 0
};
export const mediasReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_MEDIAS_LIST": {
      return initialState;
    }

    case "RESET_RESOURCES": {
      return { ...initialState };
    }
    case "FETCH_MEDIAS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }
    // case "FETCH_MEDIAS_FULFILLED": {
    //   const { data, nbResult, order } = action.payload.data;

    //   const index = order;
    //   let help = { ...state.items };
    //   if (!help[index]) {
    //     help[index] = [];
    //   }
    //   // Ovoid duplicates
    //   const newItems = (data || []).filter(newItem => {
    //     return !help[index].find(item => item.id === newItem.id);
    //   });
    //   help[index] = [...help[index].concat(newItems)];

    //   return {
    //     ...state,
    //     fetching: false,
    //     fetched: true,
    //     error: null,
    //     items: { ...help },
    //     nbResult: nbResult
    //   };
    // }
    case "FETCH_MEDIAS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data],
        nbResult: nbResult
      };
    }
    case "FETCH_MEDIAS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/media.js